import {
  getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsMutationFetcher,
  getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts201 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * 企業契約期間を新規作成する mutation hook
 *
 * @param threeLetterCode - パートナーコード（getThreeLetterCode() で取得した値）
 * @param clientId - 利用企業 ID
 * @param options - コールバックオプション
 */
export const usePostClientContractTerm = (
  threeLetterCode: string,
  clientId: number,
  options?: {
    onSuccess?: (
      data: PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts201
    ) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsMutationKey(
      threeLetterCode,
      clientId
    ),
    getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsMutationFetcher(
      threeLetterCode,
      clientId
    ),
    options
  );
};
